import { render, staticRenderFns } from "./phase-assignment-notes.vue?vue&type=template&id=dfb915b6&"
import script from "./phase-assignment-notes.vue?vue&type=script&lang=ts&"
export * from "./phase-assignment-notes.vue?vue&type=script&lang=ts&"
import style0 from "./phase-assignment-notes.vue?vue&type=style&index=0&id=dfb915b6&prod&lang=scss&"
import style1 from "./phase-assignment-notes.vue?vue&type=style&index=1&id=dfb915b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports